export default __webpack_public_path__ + "static/media/bsc.6d3feeca.png";